import { useNavigate, useParams } from 'react-router';
import { useChangePasswordForm } from '~/modules/auth/hooks/useHookForms.ts';
import { FormProvider } from 'react-hook-form';
import { Box, Button, Grid, Typography } from '@mui/material';
import { TChangePasswordForm } from '~/modules/auth/types.ts';
import { styles } from '~/modules/auth/styles.ts';
import { FormPassword } from '~/components/FormComponents/FormPassword.tsx';
import { changePassword } from '~/store/users/thunks';
import { useAppDispatch } from '~/store/appDispatch';
import { IdentificationType } from '~/modules/identification/forms/GettingStarted/types';
import FormGridItem from '~/components/FormComponents/FormGridItem';

const ChangePassword = () => {
  const { id, token } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const form = useChangePasswordForm();
  const { isSubmitting } = form.formState;

  const onSubmit = async (values: TChangePasswordForm) => {
    const newPasswordData = {
      id: id || '',
      newPassword: values.newPassword,
      token: token || '',
    };

    await dispatch(changePassword({ form: newPasswordData }));
    navigate(`/identification/questionnaire?type=${IdentificationType.PRIMARY}`);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.containerChangePassword}>
        <Typography sx={styles.headerTextChangePassword}>Відновлення паролю</Typography>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Grid>
              <FormGridItem>
                <FormPassword
                  type="password"
                  autoComplete="current-password"
                  name="newPassword"
                  label="Пароль"
                  placeholder="Введіть пароль"
                  fullWidth
                />
              </FormGridItem>
              <FormGridItem>
                <FormPassword
                  type="password"
                  autoComplete="current-password"
                  name="repeatPassword"
                  label="Продублюйте пароль"
                  placeholder="Введіть пароль повторно"
                  fullWidth
                />
              </FormGridItem>
            </Grid>

            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <Button variant="contained" type="submit" disabled={isSubmitting}>
                Підтвердити
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Box>
  );
};

export default ChangePassword;
